module.exports = __webpack_public_path__ + "img/emoji/wen.eb01aa3eaa38c507f124fdd06090bf87.png";